(ns frontend.view.profile.components.sessions
  (:require [common.localization :as loc]
            [frontend.state.current-session :as session-db]
            [frontend.bootstrap.components :as rbs]
            [frontend.zap-time :as zap-time]
            [frontend.utils :as fu]
            [ui.components.button.view :as button]))

(defn view [show-all? tokens show-all!]
  (let [tokens (->> tokens (sort-by (fn [s]
                               (or (:token/updated s)
                                   (:token/created s)
                                   0)))
                    reverse)
        selected-tokens (if show-all?
                          tokens
                          (take 20 tokens))]

    [:div
     {:class "py-6 flex flex-col gap-3"}
     [:div
      {:class "font-bold text-[18px]"}
      (loc/tr :personal-client-sessions)]
     [:div
      {:class "max-w-full overflow-auto border border-solid border-base-regular-border-paler rounded"}
      [:table 
       {:class "min-w-full divide-y divide-solid divide-base-regular-border-paler"}
       [:thead
        [:tr 
         {:class "*:py-3 *:px-2 *:text-left *:text-sm *:font-bold *:text-base-light-text"}
         [:th (loc/tr :token/updated)]
         [:th (loc/tr :token/device-type)]
         [:th (loc/tr :token/device-id)]]]
       [:tbody
        {:class ""}
        (doall (for [token selected-tokens]
                 [:tr
                  {:key (str (:db/id token))
                   :class "*:whitespace-nowrap *:px-2 *:py-3 *:text-sm *:text-base-light-text even:bg-base-regular"}
                  [:td  (zap-time/long->formatted-date-time (or (:token/updated token) (:token/created token)))]
                  [:td (:token/device-type token)]
                  [:td (:token/device-id token)]]))]]
      ]
     (when (and (not show-all?)
                (> (count tokens) 20))
       [:div
        {:class-name "flex justify-center"}
        [button/primary-open
         {:on-click   show-all!}
         (loc/tr :show-all)]])]))
